// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__B+wZq","Footer__name":"Footer_Footer__name__8WzVl","Footer__links":"Footer_Footer__links__XE4NM","Footer__link":"Footer_Footer__link__4OE-f"};